module.exports = __webpack_public_path__ + "static/media/lychee.9da9a9b3.png";